import { render, staticRenderFns } from "./MetadataForm.vue?vue&type=template&id=058e3a72&scoped=true"
import script from "./MetadataForm.vue?vue&type=script&lang=js"
export * from "./MetadataForm.vue?vue&type=script&lang=js"
import style0 from "./MetadataForm.vue?vue&type=style&index=0&id=058e3a72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e3a72",
  null
  
)

export default component.exports